const { AQL_LEVELS } = require('./aql');
const { genDefectCodes } = require('./defect-code');

const codeValues = {
  'A': { type_desc: 'Raw Material',
         codes: ['Holes',
                 'Material faults',
                 'Shading between panels',
                 'Shading between batched',
                 'Shading between ribs/trims and panels',
                 'Fabric handle inconsistent between batches',
                 'Fibre contamination',
                 'Pilling visible',
                 'Barre in fabric',
                 'Glue mark',
                 'Deformation/twist on product surface',
                 'Poor plating',
                 'Rough surface/material',
                 'Missing coating/glitter/painting',
                 'Broken elastic',
                 'Misplaced, unopened uneven distance between punch hole(s)',
                 'Other']},
  'B': { type_desc: 'Construction',
         codes: ['Broken/faulty stitching',
                 'Open seams',
                 'Seams grinning',
                 'Excessive stitch puckering (where not required)',
                 'Raw or frayed edges visible (where not required)',
                 'Missing or incorrect details e.g. missing pocket',
                 'Checks or stripes mismatched',
                 'Neckline not symmetrical',
                 'Pockets not level',
                 'Fusing delaminating',
                 'Stitching needle hole damage',
                 'Button/buttonhole, hook/loop etc. mis-aligned',
                 'Labels - incorrect position or not level',
                 'Exposed elastic',
                 'Other']},
  'C': { type_desc: 'Components',
         codes: ['Defective poppers/studs',
                 'Component broken e.g. zip/button/popper/eyelet',
                 'Component missing e.g. zip/button/popper/eyelet',
                 'Insecure component e.g. button/badge/popper/eyelet',
                 'Other']},
  'D': { type_desc: 'Embellishments',
         codes: ['Print or embroidery - incorrect position or not level',
                 'Print register not as required',
                 'Obvious print defect',
                 'Print transfer to garment',
                 'Embroidery - loose or insecure threads',
                 'Embroidery needle damage',
                 'Fabric distorted from embellishment',
                 'Other']},
  'E': { type_desc: 'Finishing',
         codes: ['Garment is wet',
                 'Mildew, damp, mould present',
                 'Odour present',
                 'Product is marked, stained, scratched or dirty',
                 'Poor pressing eg over pressed/glazing',
                 'Pressing impressions visible e.g. pocket flaps',
                 'Surface damage or colour run resulting from laundering',
                 'Untrimmed threads over 1cm',
                 'Mending',
                 'Other']},
  'F': { type_desc: 'Measurements',
         codes: ['Out of tolerance',
                 'Different sleeve or leg length within garment']},
  'G': { type_desc: 'Packaging & Labelling',
         codes: ['Damaged carton e.g. wet/bulging',
                 'Incorrect carton dimensions',
                 'Incorrect or missing carton label',
                 'Incorrect carton quantity',
                 'Carton content incorrect',
                 'Incorrect or missing carton labels',
                 'Missing care label',
                 'Incorrect care label or fibre content percentage',
                 'No warning, recycle logo or air holes on polybag',
                 'Incorrect size label',
                 'Missing country of origin label',
                 'Incorrect packaging method',
                 'Missing hangtag',
                 'Missing dessicant bag',
                 'Packaging connector or string is missing or damaged',
                 'Set is unmatched or missing pieces',
                 'Appearance defect on selling unit package',
                 'Other']},
  'H': { type_desc: 'Metal Contamination',
         codes: ['Any sharp metal contamination inc. needles, staples',
                 'Kimble gun needle, metal fragments or pins present',
                 'Any other metal object not specified on the product',
                 'Any hand tool e.g. scissors, snips, tweezers',
                 'Sharp corners and edges',
                 'Rust/corrosion/oxidation']},
  'I': { type_desc: 'Infestation',
         codes: ['Dead insect/animal',
                 'Live insect/animal']},
};

module.exports = {
  AQL_LEVELS,
  DEFECT_CODES: genDefectCodes(codeValues),
};
